const pad = n => String(n).padStart(2, '0')

export function todayLocalDate() {
  const d = new Date()
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

export function nowLocalTime() {
  const d = new Date()
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export function localTimeOf(isoDateTime) {
  if (!isoDateTime) return ''
  const d = new Date(isoDateTime)
  if (Number.isNaN(d.getTime())) return ''
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export function expenseDateForApi(isoDate, time = '') {
  const value = String(isoDate || '').slice(0, 10)
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return value

  const [y, m, d] = value.split('-').map(Number)
  const [hh, mm] = /^\d{2}:\d{2}/.test(String(time)) ? String(time).split(':').map(Number) : [12, 0]
  return new Date(y, m - 1, d, hh, mm, 0).toISOString()
}

export function localDateOf(isoDateTime) {
  if (!isoDateTime) return ''
  const d = new Date(isoDateTime)
  if (Number.isNaN(d.getTime())) return String(isoDateTime).slice(0, 10)
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}
